import React, { useState, useEffect } from 'react';
import Helmet from 'react-helmet';
import GlobalStyle from 'styles/global';
import { font } from 'styles/variables';
import Exps from 'utils/Exps';
import cookie from 'react-cookies';
import 'url-search-params-polyfill';
import UAParser from 'ua-parser-js';
import sha256 from 'js-sha256';

export default props => {
	const [config] = useState(require(`data/_config`));
	if (typeof sessionStorage !== 'undefined') {
		let sessions = JSON.parse(sessionStorage.getItem('sessions'));
		if (!sessions) {
			let ua = new UAParser().getResult();
			sessions =
				typeof document !== 'undefined'
					? {
							source: new URLSearchParams(document.location.search).get('utm_source') || null,
							medium: new URLSearchParams(document.location.search).get('utm_medium') || null,
							campaign: new URLSearchParams(document.location.search).get('utm_campaign') || null,
							term: new URLSearchParams(document.location.search).get('utm_term') || null,
							content: new URLSearchParams(document.location.search).get('utm_content') || null,
							timestamp: new Date().getTime(),
							useragent: `${ua.os.name} ${ua.os.version}, ${ua.browser.name} ${ua.browser.version} [${ua.ua}]`,
					  }
					: null;
			sessionStorage.setItem('sessions', JSON.stringify(sessions));
		}
	}
	useEffect(() => {
		if (typeof cookie.load('uid') !== 'undefined') {
			// console.log(cookie.load('uid'));
		} else {
			cookie.save('uid', Date.now() + '_' + Math.floor(Math.random() * 1000), { path: '/' });
		}
		if (
			!(
				process.env.NODE_ENV === 'production' &&
				!(typeof window !== 'undefined' && window.location.origin.indexOf('netlify') > -1)
			)
		) {
			document.getElementById('hideAll').style = '';
		}
		(function(win, doc, sdk_url) {
			if (win.snaptr) return;
			var tr = (win.snaptr = function() {
				tr.handleRequest ? tr.handleRequest.apply(tr, arguments) : tr.queue.push(arguments);
			});
			tr.queue = [];
			var s = 'script';
			var new_script_section = doc.createElement(s);
			new_script_section.async = !0;
			new_script_section.src = sdk_url;
			var insert_pos = doc.getElementsByTagName(s)[0];
			insert_pos.parentNode.insertBefore(new_script_section, insert_pos);
		})(window, document, 'https://sc-static.net/scevent.min.js');
		window.snaptr('init', '920c3d1a-6afb-44ff-b133-289ca1c3ccc8', {
			user_hashed_email: sha256(`${cookie.load('uid')}@reshape.me`),
		});
		window.snaptr('track', 'PAGE_VIEW');
	}, []);
	return (
		<>
			<Helmet>
				<html lang="en" />
				<meta charSet="utf-8" />
				<meta name="viewport" content="width=device-width, initial-scale=1, user-scalable=no" />
				<link href={font.import} rel="stylesheet" />

				<link rel="apple-touch-icon" sizes="180x180" href="/static/apple-touch-icon.png" />
				<link rel="icon" type="image/png" sizes="32x32" href="/static/favicon-32x32.png" />
				<link rel="icon" type="image/png" sizes="16x16" href="/static/favicon-16x16.png" />

				<link rel="manifest" href="/static/manifest.json" />
				<meta name="msapplication-TileColor" content={config.theme_color} />
				<meta name="theme-color" content={config.theme_color} />

				{/* <script src="/locale.js" /> */}
				<script src="https://chargedesk.com/client.js" crossorigin="anonymous"></script>

				{process.env.NODE_ENV !== 'development' && (
					<script>
						{`(function() {
							window.__insp = window.__insp || [];
							__insp.push(['wid', 1291405135]);
							var ldinsp = function(){
							if(typeof window.__inspld != "undefined") return; window.__inspld = 1; var insp = document.createElement('script'); insp.type = 'text/javascript'; insp.async = true; insp.id = "inspsync"; insp.src = ('https:' == document.location.protocol ? 'https' : 'http') + '://cdn.inspectlet.com/inspectlet.js?wid=1291405135&r=' + Math.floor(new Date().getTime()/3600000); var x = document.getElementsByTagName('script')[0]; x.parentNode.insertBefore(insp, x); };
							setTimeout(ldinsp, 0);
							})();`}
					</script>
				)}

				<script async src="https://www.googletagmanager.com/gtag/js?id=AW-625359970"></script>
				<script>
					{`window.dataLayer = window.dataLayer || [];
						function gtag(){dataLayer.push(arguments);}
						gtag('js', new Date());
						gtag('config', 'AW-625359970');`}
				</script>
			</Helmet>
			<Exps />
			{props.children}
			<div
				style={{
					display: 'block',
					position: 'fixed',
					left: '0px',
					right: '0px',
					top: '0px',
					bottom: '0px',
					backgroundColor: 'white',
					zIndex: '99',
				}}
				id="hideAll"
			/>
			<GlobalStyle />
		</>
	);
};
